import { render, staticRenderFns } from "./el-avatar.vue?vue&type=template&id=66a655cf&scoped=true&"
import script from "./el-avatar.vue?vue&type=script&lang=js&"
export * from "./el-avatar.vue?vue&type=script&lang=js&"
import style0 from "./el-avatar.vue?vue&type=style&index=0&id=66a655cf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a655cf",
  null
  
)

export default component.exports